import { useEffect } from 'react';
import { Loading } from '../../../components/Loading';
import { Container } from '../../../GlobalComponents/Container';
import { Flex } from '../../../GlobalComponents/Flex';
import { useAppDispatch, useAppSelector } from '../../../reduxstore/hooks';
import { useGetProfileInfoQuery } from '../../api';
import EmptyCard from './components/EmptyCard';
import AddCard from './containers/AddCard';
import CardView from './containers/CardView';
import { setProfile } from '../../state/profileSlice';

const Cards = (): JSX.Element => {
	const { isLoading, data } = useGetProfileInfoQuery({
		shouldFetch: true
	});
	const dispatch = useAppDispatch();
	const cardDetails = useAppSelector(
		state => state.accountReducer.profile.cards
	);

	const primaryCard = cardDetails.find(card => card.default_payment_method);

	useEffect(() => {
		if (data?.data?.profile) dispatch(setProfile(data.data.profile));
	}, [data, dispatch]);

	return (
		<Container>
			<Flex $flexDirection="column" $rowGap="24px" $margin={'16px 0 0 0'}>
				{isLoading ? (
					<Loading />
				) : cardDetails.length >= 1 ? (
					<CardView
						cardDetails={cardDetails}
						primaryCard={primaryCard}
					/>
				) : (
					<EmptyCard />
				)}
				<AddCard />
			</Flex>
		</Container>
	);
};

export default Cards;
